import Properties from "../features/Properties";
import Users from "../features/Users";
import ChatHistory from "../features/ChatHistory";
import Packages from "../features/Packages";
import WidgetSettigns from "../features/WidgetSettings";
import Members from "../features/Members";
import Dashboard from "../features/Dashboard";
import Subscriptions from "../features/Subscriptions";
import Invoices from "../features/Invoices";
import PackagePrice from "../features/PackagePrice";
import Refunds from "../features/Refunds";
import Coupons from "../features/Coupons";
import Vouchers from "../features/Vouchers";
import UserDetails from "../features/Users/UserDetails";

export const layout_routes = [
  { key: "packages", path: "/packages", element: <Packages /> },
  { key: "redunds", path: "/refunds", element: <Refunds /> },
  { key: "coupons", path: "/coupons", element: <Coupons /> },
  { key: "vouchers", path: "/vouchers", element: <Vouchers /> },

  { key: "prices", path: "/prices", element: <PackagePrice /> },

  { key: "properties", path: "/properties", element: <Properties /> },
  {
    key: "widget-settings",
    path: "/widget-settings/:propertyId",
    element: <WidgetSettigns />,
  },
  {
    key: "members",
    path: "/members/:propertyId",
    element: <Members />,
  },
  { key: "users", path: "/users", element: <Users /> },
  { key: "user-details", path: "/user/:id", element: <UserDetails /> },

  { key: "chat-history", path: "/chat-history", element: <ChatHistory /> },
  { key: "reports", path: "/reports", element: <Dashboard /> },
  { key: "subscriptions", path: "/subscriptions", element: <Subscriptions /> },
  { key: "invoices", path: "/invoices", element: <Invoices /> },
];
